import { useEffect, useState } from "react";
import TextArea from "../../genericComponents/TextArea/TextArea";
import { MAX_SECTOR_DESCRIPTION_LENGTH, Sector } from "../../../utils/lighthouseConstants";

interface SectorDescriptionAttributeProps {
    sector: Sector;
    setDescription: (description: string, sectorIndex: number) => void;
    initialText?: string;
    disabled?: boolean;
}

const SectorDescriptionAttribute = (props: SectorDescriptionAttributeProps) => {
    const { sector, setDescription, initialText, disabled } = props;
    const [text, setText] = useState("");

    useEffect(() => {
        setText(initialText ?? "");
    }, []);

    useEffect(() => {
        setText(initialText ?? "");
    }, [initialText]);

    return (
        <div>
            <span className="sector-label">Beskrivelse</span>
            <TextArea
                label=""
                value={text}
                inputFieldId=""
                onChange={(newText) => {
                    setText(newText);
                }}
                onBlur={() => {
                    setDescription(text, sector.index);
                }}
                maxLength={MAX_SECTOR_DESCRIPTION_LENGTH}
                disabled={disabled}
            />
        </div>
    );
};

export default SectorDescriptionAttribute;
